module.exports = __webpack_public_path__ + "img/Kahon-logo-white.bb9f4940.png";